import { createContext } from 'react';

import type { OrderStatusResponse } from '~/interfaces/order_status';

import type { RedemptionState } from './InstantRedemptionModal';

export interface CheckoutContextType {
  clientSecret: string | null;
  setClientSecret: (secret: string | null) => void;
  redemptionToken: string | null;
  setRedemptionToken: (token: string | null) => void;
  showThankYou: boolean;
  setShowThankYou: (show: boolean) => void;
  showRedemptionModal: boolean;
  setShowRedemptionModal: (show: boolean) => void;
  redemptionState: RedemptionState;
  setRedemptionState: (state: RedemptionState) => void;
  orderStatusData: OrderStatusResponse['order'] | null;
  setOrderStatusData: (data: OrderStatusResponse['order'] | null) => void;
  redemptionErrorMessage: string | null;
  setRedemptionErrorMessage: (message: string | null) => void;
  shouldInstantlyRedeem: boolean;
  showFreeProductCheckoutModal: boolean;
  setShowFreeProductCheckoutModal: (show: boolean) => void;
}

/** @deprecated Use CheckoutContext instead */
export type ClientSecretContextType = CheckoutContextType;

export const ClientSecretContext = createContext<CheckoutContextType | undefined>(undefined);

/** Alias for ClientSecretContext */
export const CheckoutContext = ClientSecretContext;
